var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-taginput',{attrs:{"icon":"tag","placeholder":"Enter value"},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72696640","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/components/TagInput.vue
// module id = uSoY
// module chunks = 1